import axios from '../utils/axios';
import  { v4 as uuidv4 } from 'uuid';

const SERVICE_URL = '/products';

export const getProductsList = async ({
    searchTerm,
    page,
    rowsPerPage,
    lastEvaluatedKey,
    sortAscending,
    filteredCharacteristic,
    fullSearch=false,
    ignoredFields=[]
}) => {
    try {
        let response = await axios.post(
            `${SERVICE_URL}`
            , 
            { 
                searchTerm,
                page,
                rowsPerPage,
                lastEvaluatedKey,
                sortAscending,
                filteredCharacteristic,
                fullSearch,
                ignoredFields
            }
        );
        return response.data;
    } catch (error) {
        return {
            items: [], 
            lastEvaluatedKey: null,
            count: 0
        };
    }
}

export const getProductsAll = async () => {
    try {
        let response = await axios.get( `${SERVICE_URL}/all`);
        return response.data;
    } catch (error) {
        return {
            error
        };
    }
}

// export const getProductVariantsList = async (
//     searchTerm,
//     page,
//     rowsPerPage,
//     LastEvaluatedKey
// ) => {
//     try {
//         let response = await axios.post(
//             `${SERVICE_URL}/variants`
//             , 
//             { 
//                 searchTerm,
//                 page,
//                 rowsPerPage,
//                 LastEvaluatedKey
//             }
//         );
//         return response.data;
//     } catch (error) {
//         return {
//             Items: [], 
//             LastEvaluatedKey: {},
//             totalPages: 1
//         };
//     }
// }

// export const productVariantsCreate = async (formData) => {

//     try {
//         console.log("PROD VAR FORM CREATE", formData)
//         // return

//         let response = await axios.post(`${SERVICE_URL}/variants/create`, formData );
//         return response.data;
//     } catch (error) {
//         return {
//             result: false,
//             error
//         };
//     }
// }

export const getProductsById = async (
    productId
) => {

    try {
        let response = await axios.post( `${SERVICE_URL}/id` , { id: productId } );

        // console.log("🚀 ~ getProductsById ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            error
        };
    }
}

export const productsCreate = async (formData) => {

    try {
        // console.log("PROD FORM CREATE", formData)

        let response = await axios.post(`${SERVICE_URL}/create`, formData );

        // console.log("🚀 ~ productsCreate ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsUpdate = async (formData) => {

    try {
        // console.log("PROD FORM UPDATE", formData)
        
        let response = await axios.put(`${SERVICE_URL}/update`, formData );

        // console.log("🚀 ~ productsUpdate ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productStockUpdate = async (formData) => {
    try {
        let response = await axios.put(`${SERVICE_URL}/stock/update`, formData);

        // console.log("🚀 ~ productStockUpdate ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

// export const productVarianStockUpdate = async (data) => {

//     try {
//         let response = await axios.put(`${SERVICE_URL}/variants/stock`, data );
//         return response.data;
//     } catch (error) {
//         return {
//             result: false,
//             error
//         };
//     }
// }

// export const productVarianStockUpdateByCsv = async (items) => {
//     return axios.post(`${SERVICE_URL}/variants/update-csv`, { items } )
// }

export const productsDelete = async (_id) => {
    try {
        let response = await axios.delete(`${SERVICE_URL}/delete?id=${_id}`);

        // console.log("🚀 ~ productsDelete ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsGetImageUrl = async (extension) => {
    const id = uuidv4();
    try {
        // console.log(`PRODUCT IMATE URL UPLOAD: ${SERVICE_URL}/imagelink?name=${id}${extension}&type=image`)
        let response = await axios.get(`${SERVICE_URL}/imagelink?name=${id}${extension}&type=image`);

        // console.log("🚀 ~ productsGetImageUrl ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsGetFileUrl = async (name) => {
    try {

        // console.log(`PRODUCT FILE URL UPLOAD: ${SERVICE_URL}/imagelink?name=${name}&type=file`)
        let response = await axios.get(`${SERVICE_URL}/imagelink?name=${name}&type=file`);

        // console.log("🚀 ~ productsGetFileUrl ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsUploadImage = async (image, imageUrl) => {
    try {
        // console.log("🚀 ~ productsUploadImage ~ imageUrl:", imageUrl)
        // console.log("🚀 ~ productsUploadImage ~ image:", image)
        await fetch(imageUrl, {
            method:'PUT',
            body: image,
            headers: {
                'Content-Type': `${image.type}`,
            }
        });
        return { result: true };
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsGetImageUrlToDelete = async (url) => {
    try {
        // console.log(`PRODUCT IMATE URL DELETE: ${SERVICE_URL}/imagelinktodelete?imageId=${url}`)
        let response = await axios.get(`${SERVICE_URL}/imagelinktodelete?imageId=${url}`);

        // console.log("🚀 ~ productsGetImageUrlToDelete ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsDeleteImage = async (url) => {
    try {
        await fetch(url, {
            method:'DELETE',
        });
        return { result: true };
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productsUploadCsv = async (data) => {

    try {
        let response = await axios.post(`${SERVICE_URL}/uploadcsv`, data );

        // console.log("🚀 ~ productsUploadCsv ~ response:", response.data)
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}


const formatURL = (url) => {
    return url.replace("//", "/");
}